import { type JSX, Show } from 'solid-js';
import { t } from '../i18n';
import { FleetLiveIcon } from './FleetLiveIcon';

// The ghost a dragged Fleet Live panel leaves under the pointer (#6779, prototype
// `.fl-pghost`, `:3672`): "<PANEL NAME>" and "→ <ZONE>" for the zone under the pointer.
// Decorative and pointer-only (the keyboard path is "Place in"), so it is hidden from
// assistive tech; the move itself is announced.

export function FleetLiveDragGhost(props: {
  readonly panel: string | null;
  readonly zone: string | null;
  readonly at: { readonly x: number; readonly y: number } | null;
}): JSX.Element {
  return (
    <Show when={props.panel !== null && props.at}>
      {(at) => (
        <div
          class="fleet-live__ghost"
          aria-hidden="true"
          style={{ transform: `translate3d(${at().x + 14}px, ${at().y + 12}px, 0)` }}
        >
          <span>
            <FleetLiveIcon name="move" />
            {props.panel?.toUpperCase()}
          </span>
          <Show when={props.zone}>
            {(z) => <b>{t('fleet.live.ghost_zone', { zone: z().toUpperCase() })}</b>}
          </Show>
        </div>
      )}
    </Show>
  );
}
